<template>
  <v-dialog :value="isOpened" max-width="420px" @input="handleClose">
    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="py-6">
        <p class="text-subtitle-1 mb-0 text-center">
          {{ message }}
        </p>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="handleClose">
          {{ $t('miscellaneous.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn color="primary" dark :loading="isLoading" @click="confirm">
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PaymentMethodConfirmationDialog',
  props: {
    isBeingAddedToArena: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isOpened: { type: Boolean, required: true },
    itemName: { type: String, default: '' },
  },
  computed: {
    confirmLabel() {
      return this.isBeingAddedToArena
        ? this.$t('miscellaneous.add')
        : this.$t('miscellaneous.remove')
    },
    message() {
      return this.isBeingAddedToArena
        ? this.$t('entities.paymentMethods.addToArenaMessage', {
            name: this.itemName,
          })
        : this.$t('entities.paymentMethods.removeFromArenaMessage', {
            name: this.itemName,
          })
    },
    title() {
      return this.isBeingAddedToArena
        ? this.$t('entities.paymentMethods.addToArena')
        : this.$t('entities.paymentMethods.removeFromArena')
    },
  },
  methods: {
    confirm() {
      return this.$emit('dialog:confirm')
    },
    handleClose() {
      return this.$emit('dialog:close')
    },
  },
}
</script>
